export default __webpack_public_path__ + "static/media/platinum.3636588f.png";